module.exports = __webpack_public_path__ + "assets/img/36_1500.4da266fb.jpg";